export default "__VITE_ASSET__Bh$uvYpY__"